<script setup lang="ts">
  defineSlots<{
    default: () => unknown
  }>()
</script>

<template>
  <div class="text-muted-foreground text-xs">
    <slot />
  </div>
</template>
